import React, { useEffect, useState } from "react";

const SelectByModel = (props) => {
  const { selectedModel, onSelectedModel, modelsData, index, modelErrors } = props;
  const [selectModelByUser, setSelectModelByUser] = useState();

  useEffect(() => {
    setData();
  }, [selectedModel]);

  const setData = () => {
    if (
      selectedModel !== null &&
      selectedModel !== undefined &&
      selectedModel !== ""
    ) {
      setSelectModelByUser(selectedModel);
    } else {
      setSelectModelByUser("-1");
    }
  };

  const selectByModelHandler = (e) => {
    const selectedVal = e.target.value;
    onSelectedModel(selectedVal, "ModelId",index);
    //onSearchByModel(selectedVal);
  };

  return (
    <>
      <div className="input-wrapper margin-bottom">
        <select
          className={`skill-filter-field w-select ${modelErrors?.[index]?.ModelId ? "border-red" : ""
            }`}
          onChange={(e) => selectByModelHandler(e)}
          value={selectModelByUser}
        >
          <option value="-1">Select Model</option>
          {modelsData?.map((item) => (
            <option key={item.Id} value={item.Id}>
              {item.Name}
            </option>
          ))}
        </select>
        {
          modelErrors?.[index]?.ModelId && (
            <span className="error-text">
              {modelErrors[index].ModelId}
            </span>
          )
        }
      </div>
    </>
  );
};

export default SelectByModel;
